import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/share'
@Injectable({
  providedIn: 'root'
})
export class LocalstorageService implements OnDestroy {
  private onSubject = new Subject<{ key: string, value: any }>();
  public changes = this.onSubject.asObservable().share();
  private readonly ZONE_STORAGE_KEY = 'fuseauHoraire';

  constructor() {
    // Automatically detect and store timezone on startup if not already set
    this.initializeZone();
  }
  ngOnDestroy() {
    this.stop();
  }

  public getStorage() {
    let s = [];
    for (let i = 0; i < localStorage.length; i++) {
      s.push({
        key: localStorage.key(i),
        value: JSON.parse(localStorage.getItem(localStorage.key(i)))
      });
    }
    return s;
  }

  public store(key: string, data: any): void {
    localStorage.setItem(key, JSON.stringify(data));
    //the local application doesn't seem to catch changes to localStorage...
    this.onSubject.next({ key: key, value: data })
  }

  public clear(key) {
    localStorage.removeItem(key);
    //the local application doesn't seem to catch changes to localStorage...
    this.onSubject.next({ key: key, value: null });
  }


  public start(): void {
    window.addEventListener("storage", this.storageEventListener.bind(this));
  }

  public storageEventListener(event: StorageEvent) {

    window.location.reload()
    if (event.storageArea == localStorage) {

      let v;
      try { v = JSON.parse(event.newValue); }
      catch (e) { v = event.newValue; }
      this.onSubject.next({ key: event.key, value: v });
    }
  }

  public stop(): void {
    window.removeEventListener("storage", this.storageEventListener.bind(this));
    this.onSubject.complete();
  }


  private lang = new BehaviorSubject<string>(localStorage.getItem("lang") == null ? 'fr' : localStorage.getItem("lang"));
  currentlang = this.lang.asObservable();
  changelang(valeur: string) {
    this.lang.next(valeur)
  }

  private sidebarvar = new BehaviorSubject<Boolean>(false);
  currentsidebarvar = this.sidebarvar.asObservable();
  changesidebarvar(valeur: Boolean) {
    this.sidebarvar.next(valeur)
  }
  private getfonc = new BehaviorSubject<string>('');
  currentfonc = this.getfonc.asObservable();
  changefonc(valeur: string) {
    this.getfonc.next(valeur)
  }

  // private getlistfonc=new BehaviorSubject<AdmFonc[]>([]);
  // currentlistfonc= this.getlistfonc.asObservable();
  // changelistfonc(valeur:AdmFonc[]){
  //   this.getlistfonc.next(valeur)
  // }


  private getaccess = new BehaviorSubject<boolean>(false);
  currentaccess = this.getaccess.asObservable();
  changeaccess(valeur: boolean) {
    this.getaccess.next(valeur)
  }

  private sidebarrole = new BehaviorSubject<string>(null);
  currentsidebarrole = this.sidebarrole.asObservable();
  changesidebarroler(valeur: string) {
    this.sidebarrole.next(valeur)
  }

  /**
   * Initialize zone on service startup
   * Auto-detects browser timezone if not already stored
   */
  private initializeZone(): void {
    const storedZone = localStorage.getItem(this.ZONE_STORAGE_KEY);

    if (!storedZone) {
      // Auto-detect timezone from browser
      const detectedZone = this.detectBrowserTimezone();
      this.setFuseauHoraire(detectedZone);
    }
  }

  /**
   * Detect the browser's timezone
   * @returns timezone string (e.g., "Europe/Paris", "Asia/Tokyo")
   */
  private detectBrowserTimezone(): string {
    try {
      return Intl.DateTimeFormat().resolvedOptions().timeZone;
    } catch (e) {
      console.warn('Unable to detect timezone, defaulting to Africa/Tunis', e);
      return 'Africa/Tunis';
    }
  }

  /**
   * Get the current fuseau horaire (time zone)
   * @returns the stored zone ID or 'Africa/Tunis' as fallback
   */
  public getFuseauHoraire(): string {
    const zone = localStorage.getItem(this.ZONE_STORAGE_KEY);
    if (!zone) {
      return 'Africa/Tunis';
    }
    try {
      const parsed = JSON.parse(zone);
      return typeof parsed === 'string' && parsed.length > 0 ? parsed : 'Africa/Tunis';
    } catch {
      return 'Africa/Tunis';
    }
  }

  /**
   * Set/update the fuseau horaire (time zone)
   * @param zoneId - the timezone ID (e.g., "Europe/Paris")
   */
  public setFuseauHoraire(zoneId: string): void {
    this.store(this.ZONE_STORAGE_KEY, zoneId);
    this.fuseauHoraire.next(zoneId);
  }

  /**
   * Clear the stored fuseau horaire
   */
  public clearFuseauHoraire(): void {
    this.clear(this.ZONE_STORAGE_KEY);
    this.fuseauHoraire.next('Africa/Tunis');
  }

  /**
   * BehaviorSubject for reactive zone changes
   * Allows components to subscribe to zone changes
   */
  private fuseauHoraire = new BehaviorSubject<string>(this.getFuseauHoraire());
  currentFuseauHoraire = this.fuseauHoraire.asObservable();

  /**
   * Update fuseau horaire and notify subscribers
   * @param zoneId - the new timezone ID
   */
  changeFuseauHoraire(zoneId: string) {
    this.setFuseauHoraire(zoneId);
  }


}
